import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';

export const Content = ({ isAddToCart, onClose, addProductToCart }) => (
  <article className="free-mobile-fitting-light-box">
    <header className="free-mobile-fitting-light-box__header">
      <Translation
        tagName="h2"
        className="free-mobile-fitting-light-box__headline"
        translationKey="clearance-info-lightbox-headline"
      />

      <div className="free-mobile-fitting-light-box__sub-header">
        <Translation tagName="p" translationKey="clearance-info-lightbox-detail" />
      </div>
    </header>
    <footer className="free-mobile-fitting-light-box__footer">
      <Translation
        tagName="button"
        className="free-mobile-fitting-light-box__primary-cta"
        onClick={!isAddToCart ? onClose : addProductToCart}
        translationKey={`${
          !isAddToCart ? 'clearance-info-lightbox-button' : 'clearance-info-lightbox-add-to-cart-button'
        }`}
      />
    </footer>
  </article>
);

Content.propTypes = {
  isAddToCart: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  addProductToCart: PropTypes.func.isRequired,
};
